/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-color-literals */
import React, {
  useState,
  useRef,
  useLayoutEffect,
  Suspense,
  useEffect,
} from 'react';
import { Pressable, StyleSheet, Text, View, Dimensions } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';

import WithLocalSvg from '@web-components/common/WithLocalSvg';
import Button from '@web-components/form/Button';
import OtpInputs from '@web-components/form/input-extends/OtpInputs';
import ErrorCodes from '~global/ErrorCodes';
import { formatPhoneNo } from '~global/helpers';
import Toast from 'react-native-toast-message';
import Colors from '~global/Colors';
import * as authActions from '~store/user/actions/auth';
const ModalListCountries = React.lazy(() =>
  import('@web-components/modals/ModalListCountries'),
);
import Modal from '@web-components/common/modal/Modal';
import * as location from '~store/location/thunks';

const { width: windowWidth } = Dimensions.get('window');

import { isNative, isWeb } from '~global/screens';

const OtpVerificationScreen = (props) => {
  const {
    navigation,
    forgot,
    email,
    phone_no,
    quick_registration,
    fullscreen,
    destinationRoute,
    verificationMethod,
    handleResend,
    handleScreenChange,
    onChangePhoneNumber,
    phone_code,
    user_id,
    hash,
  } = props;
  const dispatch = useDispatch();
  const { isShow: isModalVerifyAccount } = useSelector(
    (state) => state.modal.verifyAccount,
  );
  const { countries } = useSelector((state) => state.location);
  const [isDisabled, setIsDisabled] = useState(true);
  const [phone_no1, setPhone] = useState(['+62', '']);
  const otp = useRef('');
  const [seconds, setSeconds] = useState(30);
  const [errorMessage, setErrorMessage] = useState('');
  const [isError, setIsError] = useState(false);
  const [counter, setcount] = useState(1);
  const text1 = 'Reach Maximum OTP Request ';
  const text2 = ' (5 Request / day)';

  const isShowModalCountries = useSelector(
    (state) => state.modal.listCountries.isShow,
  );
  const dataModalCountries = useSelector(
    (state) => state.modal.listCountries.data,
  );

  useLayoutEffect(() => {
    dispatch(
      location.countries({
        filter: { is_active: true },
        sort: 'name',
        skip: 0,
        limit: 100,
      }),
    );
  }, [dispatch]);
  const modeData = {
    whatsapp: {
      imageSrc: require('~assets/img/common/whatsapp-logo.svg'),
      imageWidth: isWeb ? 73 : 57,
      imageHeight: isWeb ? 73 : 57,
      name: 'WhatsApp',
    },
    sms: {
      imageSrc: require('~assets/img/smartphone-v2.svg'),
      imageWidth: 70,
      imageHeight: 60,
      name: 'SMS',
    },
    email: {
      imageSrc: require('~assets/img/icon-mail.svg'),
      imageWidth: isWeb ? 73 : 57,
      imageHeight: isWeb ? 68 : 57,
      name: 'email',
    },
  };
  const forgotPassword = useSelector((state) => state.auth.forgotPassword);

  // ..........hooks
  React.useEffect(() => {
    const myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      } else {
        setSeconds(false);
        clearInterval(myInterval);
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  });

  React.useEffect(() => {
    setSeconds(30);
  }, [phone_no]);

  //   ..........methods
  const verificationMethodData = modeData[verificationMethod];

  const getOtpHandler = (code) => {
    otp.current = code.join('');
    setIsDisabled(!(otp.current.length === 6));
  };

  const onVerify = async (code) => {
    const entity = verificationMethod == 'email' ? 'email' : 'phone_no';

    const payload = {
      code: otp.current,
      entity,
      mode: verificationMethod,
      [entity]: props[entity],
      user_id: user_id,
      ...(entity === 'phone_no' && { phone_code }),
    };

    if (quick_registration && entity === 'phone_no') {
      const payload = {
        mode: verificationMethod,
        code: otp.current,
        entity: 'phone_no',
        entity_value: phone_no,
        phone_code: phone_code,
        user_id: user_id,
        hash,
      };
      const res = await dispatch(authActions.getOtpLogin(payload));
      if (res.success) {
        navigation.navigate('QuickRegisterSignUpScreen');
      } else {
        setIsError(true);
        Toast.show({ text1: res.errorCode, type: 'error' });
      }
      return;
    }

    if (forgot) {
      payload['user_id'] = forgotPassword.user_id || '';
      payload['entity'] = 'password';
    }
    const res = await dispatch(authActions.otpVerify(payload));
    if (
      forgot &&
      (res?.errorCode == 'ALREADY_VERIFIED_PHONE' || res.status === 'VERIFIED')
    ) {
      dispatch({
        type: 'SET_FORGOT_PASSWORD',
        data: {
          code: payload.code,
        },
      });
      navigation.navigate('ResetPasswordScreen');
      return;
    }
    if (res?.errorCode) {
      setIsError(true);
      Toast.show({ text1: res.errorCode, type: 'error' });
      return setErrorMessage(ErrorCodes[res.errorCode]);
    }
    if (res.status === 'VERIFIED') {
      if (isModalVerifyAccount) {
        dispatch({
          type: 'SET_USER_DATA',
          data: {
            phone_no: props.phone_no,
            is_verified_phone: true,
          },
        });
        dispatch({ type: 'MODAL/HIDE', modalName: 'verifyAccount' });
        Toast.show({
          text1:
            props.state == 'change-number'
              ? 'Phone number changed'
              : 'Congrats! Your account is verified!',
          position: 'top',
          topOffset: 60,
        });
        return;
      }
      if (quick_registration) {
        return navigation.navigate('QuickRegisterSignUpScreen', {
          phone_no: props.phone_no,
        });
      }

      if (props.phone_no) {
        dispatch({
          type: 'SET_USER_DATA',
          data: {
            phone_no: props.phone_no,
            is_verified_phone: true,
          },
        });
      }
      Toast.show({
        text1:
          props.state == 'change-number'
            ? 'Phone number changed'
            : 'Congrats! Your account is verified!',
        position: 'top',
        topOffset: 60,
      });

      if (props.previous && props.phone_no) {
        props.navigation.navigate(props.previous.screen, props.previous.params);
        return;
      }

      if (isWeb) {
        dispatch({ type: 'MODAL/HIDE', modalName: 'verifyAccount' });
        if (fullscreen) {
          try {
            navigation.reset({
              index: 0,
              routes: [{ name: 'HomeScreen' }],
            });
          } catch (error) {
            navigation.navigate('HomeScreen');
          }
        }
      } else {
        destinationRoute
          ? navigation.reset({
              index: 0,
              routes: [{ name: destinationRoute }],
            })
          : navigation.goBack();
      }
      dispatch({
        type: 'SET_USER_DATA',
        data: { is_verified_phone: true },
      });
    }
  };

  const changePhoneNumberHandler = () => {
    setSeconds(false);
    onChangePhoneNumber();
  };

  const resendHandler = () => {
    setcount(counter + 1);
    if (counter > 5) {
      console.log('err');
    } else {
      handleResend();
      setSeconds(30);
    }
  };

  const closeHandler = () => {
    dispatch({ type: 'MODAL/HIDE', modalName: 'listCountries' });
  };

  const modalProps = {
    countries,
  };

  useEffect(() => {
    if (dataModalCountries && dataModalCountries.phone_code) {
      setPhone(
        phone_no1.map((item, index) =>
          index === 0 ? dataModalCountries.phone_code : item,
        ),
      );
    }
  }, [dataModalCountries]);

  return (
    <View style={styles.container}>
      {isWeb && <Text style={styles.title}>Verification</Text>}
      <View style={styles.verificationMethodContainer}>
        {Boolean(verificationMethodData) &&
          Object.keys(verificationMethodData).length > 1 && (
            <>
              <WithLocalSvg
                key={verificationMethod}
                width={verificationMethodData.imageWidth}
                height={verificationMethodData.imageHeight}
                style={[
                  styles.imageBanner,
                  {
                    width: verificationMethodData.imageWidth,
                    height: verificationMethodData.imageHeight,
                  },
                ]}
                asset={verificationMethodData.imageSrc}
              />

              <Text style={styles.textInfo}>
                Kami telah mengirimkan kode verifikasi melalui{' '}
                {verificationMethodData.name} ke{' '}
                <Text style={styles.textInfoHighlight}>
                  {verificationMethod === 'email'
                    ? email
                    : formatPhoneNo(phone_no)}
                </Text>
              </Text>
            </>
          )}

        <Text style={[styles.textInfo, { lineHeight: 20 }]}>
          Masukkan kode verifikasi
        </Text>

        <View style={styles.container}>
          <OtpInputs
            getOtp={(code) => getOtpHandler(code)}
            secureTextEntry={isNative ? true : false}
            statusOtp={isError}
          />
        </View>
      </View>
      {errorMessage !== undefined && errorMessage.length > 0 && (
        <Text style={{ color: '#111', fontSize: 12, marginBottom: 10 }}>
          {errorMessage}
        </Text>
      )}
      <View style={styles.footer}>
        <Button
          style={styles.button}
          title="Verify"
          disabled={isDisabled}
          disabledStyle={{ backgroundColor: Colors.purple34 }}
          onPress={() => onVerify()}
        />

        {!seconds ? (
          <Text
            style={
              (styles.textInfoWaiting,
              { textAlign: 'center', color: '#5C5263', marginTop: 21 })
            }>
            {' '}
            Did not receive the verification code?{'\n'}
            <Text
              onPress={() => resendHandler()}
              style={
                counter > 5
                  ? [{ color: 'red' }]
                  : [
                      styles.textInfoWaiting,
                      styles.textInfoWaitingHighlight,
                      { textDecorationLine: 'underline' },
                    ]
              }>
              {counter > 5 ? text1 : ' Resend '}
            </Text>
            {counter > 5 ? '' : 'or'}
            <Text
              onPress={() => handleScreenChange()}
              style={
                counter > 5
                  ? [{ color: 'red' }]
                  : [
                      styles.textInfoWaiting,
                      styles.textInfoWaitingHighlight,
                      { textDecorationLine: 'underline' },
                    ]
              }>
              {counter > 5 ? text2 : ' Change verification method '}
            </Text>
          </Text>
        ) : (
          <Text style={[styles.textInfo, styles.textInfoWaiting]}>
            Wait <Text style={styles.textInfoHighlight}>{seconds} seconds</Text>{' '}
            before resending
          </Text>
        )}
      </View>
      {verificationMethod !== 'email' && (
        <Pressable
          style={[styles.cursorPointer, styles.bottomPosition]}
          onPress={changePhoneNumberHandler}>
          <Text style={styles.textChangesNumber}>
            Incorrect phone number?{' '}
            <Text
              style={[
                styles.textInfoWaitingHighlight,
                { textDecorationLine: 'underline' },
              ]}>
              Change number
            </Text>
          </Text>
        </Pressable>
      )}

      <Modal
        isVisible={isShowModalCountries}
        style={StyleSheet.flatten(styles.modalCountryWebContainer)}
        onClose={() => closeHandler()}
        isBottomSheet
        maxWidth={windowWidth}>
        <Suspense fallback={<></>}>
          <ModalListCountries {...modalProps} />
        </Suspense>
      </Modal>
    </View>
  );
};

const styles = StyleSheet.create({
  title: {
    alignSelf: 'flex-start',
    color: '#25182E',
    fontFamily: 'figtree-bold',
    fontSize: 16,
    lineHeight: 24,
    marginBottom: 24,
  },

  button: {
    marginBottom: 21,
  },
  cursorPointer: {
    ...(isWeb && { cursor: 'pointer' }),
  },
  bottomPosition: {
    position: isWeb ? 'relative' : 'absolute',
    bottom: 0,
    zIndex: 9,
  },
  container: {
    paddingTop: isWeb ? 0 : 30,
    alignItems: 'center',
    flex: 1,
    position: 'relative',
  },
  footer: {
    width: '100%',
  },
  imageBanner: {
    marginBottom: 32,
  },
  textChangesNumber: {
    paddingHorizontal: 20,
    paddingVertical: 24,
    textAlign: 'center',
    width: '100%',
    fontFamily: 'figtree-medium',
    fontSize: 14,
    lineHeight: 19,
    color: '#5C5263',
  },
  textInfo: {
    color: '#5C5263',
    fontSize: 14,
    fontFamily: 'figtree-medium',
    lineHeight: 22,
    letterSpacing: 0,
    marginBottom: 20,
    textAlign: 'center',
  },
  textInfoHighlight: {
    color: '#5C5263',
    fontFamily: 'figtree-medium',
    fontSize: 14,
    lineHeight: 22,
  },
  textInfoWaiting: {
    fontSize: 13,
    lineHeight: 20,
    marginTop: 21,
    fontFamily: 'figtree-bold',
    color: '#5C5263',
  },
  textInfoWaitingHighlight: {
    color: Colors.purple4,
  },
  verificationMethodContainer: {
    width: 261,
    alignItems: 'center',
  },
  modalCountryWebContainer: {
    ...(isWeb && { margin: 'auto', top: 190, right: 26 }),
  },
});

export default OtpVerificationScreen;
